import React from 'react';
import { CardFooterProps } from './types';
import './Card.css';

const CardFooter: React.FC<CardFooterProps> = ({
  children,
  actions,
  metadata,
  className = '',
  sx = {},
}) => {
  const footerClasses = [
    'raith-card__footer',
    className
  ].filter(Boolean).join(' ');

  // If children is provided, use it directly
  if (children) {
    return (
      <div className={footerClasses} style={sx}>
        {children}
      </div>
    );
  }

  // Otherwise, use the structured layout with actions and metadata
  return (
    <div className={footerClasses} style={sx}>
      {actions && (
        <div className="raith-card__footer-actions">
          {actions}
        </div>
      )}
      {metadata && (
        <div className="raith-card__footer-metadata">
          {metadata}
        </div>
      )}
    </div>
  );
};

export default CardFooter;